export default "__VITE_ASSET__CqZvsrR$__"